import type { AlertItem, AlertRule } from '@/shared/types'
import { TARGETS } from './targets'

export const ALERT_RULES: AlertRule[] = [
  { id: 'ar-1', code: 'AR-IN01', name: 'Mục tiêu xâm nhập không phận', category: 'intrusion', condition: 'classification = unknown AND in_airspace = true', severity: 'critical', enabled: true, triggeredCount: 12 },
  { id: 'ar-2', code: 'AR-IN02', name: 'Mục tiêu đối phương phát hiện', category: 'intrusion', condition: 'classification = foe', severity: 'critical', enabled: true, triggeredCount: 4 },
  { id: 'ar-3', code: 'AR-UN01', name: 'Mục tiêu chưa định danh > 5 phút', category: 'unidentified', condition: 'classification = unknown AND tracking_duration > 300s', severity: 'warning', enabled: true, triggeredCount: 28 },
  { id: 'ar-4', code: 'AR-SP01', name: 'Tốc độ vượt ngưỡng', category: 'speed', condition: 'speed > 1000 km/h', severity: 'warning', enabled: true, triggeredCount: 7 },
  { id: 'ar-5', code: 'AR-AL01', name: 'Độ cao bất thường', category: 'altitude', condition: 'altitude > 18000 m OR altitude < 100 m', severity: 'warning', enabled: true, triggeredCount: 3 },
  { id: 'ar-6', code: 'AR-CR01', name: 'Mục tiêu rời hành lang bay', category: 'corridor', condition: 'in_corridor = false AND scheduled_corridor != null', severity: 'warning', enabled: true, triggeredCount: 9 },
  { id: 'ar-7', code: 'AR-CR02', name: 'Mục tiêu vào vùng cấm bay', category: 'corridor', condition: 'in_restricted_zone = true', severity: 'critical', enabled: true, triggeredCount: 1 },
  { id: 'ar-8', code: 'AR-UN02', name: 'UAV/Flycam phát hiện', category: 'unidentified', condition: 'category = drone AND classification != friend', severity: 'warning', enabled: true, triggeredCount: 18 },
]

const SAMPLE_RULES = [
  { code: 'AR-IN01', name: 'Mục tiêu xâm nhập không phận', sev: 'critical' as const },
  { code: 'AR-UN01', name: 'Mục tiêu chưa định danh > 5 phút', sev: 'warning' as const },
  { code: 'AR-SP01', name: 'Tốc độ vượt ngưỡng', sev: 'warning' as const },
  { code: 'AR-CR01', name: 'Mục tiêu rời hành lang bay', sev: 'warning' as const },
  { code: 'AR-UN02', name: 'UAV/Flycam phát hiện', sev: 'warning' as const },
  { code: 'AR-IN02', name: 'Mục tiêu đối phương phát hiện', sev: 'critical' as const },
]

function generateAlerts(): AlertItem[] {
  const list: AlertItem[] = []
  const now = Date.now()
  for (let i = 0; i < 35; i++) {
    const rule = SAMPLE_RULES[i % SAMPLE_RULES.length]
    const target = TARGETS[i % TARGETS.length]
    const status: AlertItem['status'] = i < 8 ? 'active' : i < 18 ? 'acknowledged' : i < 32 ? 'resolved' : 'expired'
    const ago = i * 90 + Math.random() * 60
    list.push({
      id: `al-${i + 1}`,
      ruleCode: rule.code,
      ruleName: rule.name,
      severity: rule.sev,
      status,
      targetTrackId: target.trackId,
      message: `${rule.name} — ${target.trackId} (${target.classification === 'unknown' ? 'chưa rõ' : target.classification === 'foe' ? 'đối phương' : 'dân dụng'})`,
      createdAt: new Date(now - ago * 1000).toISOString(),
      acknowledgedBy: status !== 'active' ? 'Trung uý Nguyễn Văn Hải' : undefined,
      acknowledgedAt: status !== 'active' ? new Date(now - (ago - 120) * 1000).toISOString() : undefined,
    })
  }
  return list
}

export const ALERTS: AlertItem[] = generateAlerts()
